import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRoles = [] 
}) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  // Показываем загрузку пока проверяем авторизацию
  if (isLoading) {
    return (
      <Box 
        display="flex" 
        flexDirection="column"
        justifyContent="center" 
        alignItems="center" 
        height="100vh"
        gap={2}
      >
        <CircularProgress size={40} />
        <Typography variant="body2" color="text.secondary">
          Проверка авторизации...
        </Typography>
      </Box>
    );
  }

  // Если не авторизован - перенаправляем на логин
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Если требуются определенные роли - проверяем
  if (requiredRoles.length > 0 && user) {
    const hasRequiredRole = requiredRoles.includes(user.role);
    if (!hasRequiredRole) {
      return (
        <Box 
          display="flex" 
          flexDirection="column"
          justifyContent="center" 
          alignItems="center" 
          height="100vh"
          gap={2}
        >
          <Typography variant="h5" color="error">
            Недостаточно прав
          </Typography>
          <Typography variant="body1" color="text.secondary">
            У вас нет доступа к этой странице
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Требуемые роли: {requiredRoles.join(', ')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Ваша роль: {user.role}
          </Typography>
        </Box>
      );
    }
  }

  // Все проверки пройдены - показываем компонент
  return <>{children}</>;
};

export default ProtectedRoute;

